// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"171":"ef094895","412":"fe45f21d"}[chunkId] + ".css";
};